import React, { Component } from "react";
import "./css/homepagenews.css";
import { PostData } from "../../api/service";
import { Link, Typography } from "@material-ui/core";
//import Marquee from "react-easy-marquee";
import NewMarquee from "./NewMarquee";
import Marquee from "react-fast-marquee";
import { Button } from "antd";


export default class HomePageNews extends Component {
  state = {
    news: [],
    isLoaded: false,
  };

  // Parse a "dd-mm-yyyy" string into a sortable timestamp.
  __toTime = (d) => {
    if (!d || typeof d !== "string") return 0;
    const parts = d.split("-");
    if (parts.length === 3) {
      return new Date(`${parts[2]}-${parts[1]}-${parts[0]}`).getTime() || 0;
    }
    return new Date(d).getTime() || 0;
  };

  // Year-month key (yyyy-mm) used to isolate the latest month.
  __ymKey = (d) => {
    if (!d || typeof d !== "string") return "";
    const parts = d.split("-");
    return parts.length === 3 ? `${parts[2]}-${parts[1]}` : "";
  };

  componentDidMount() {
    // perform the api call

    let d = {
      type: this.props.type,
      dept_code: this.props.dept_code || "NSS",
      year: ""
    };

    PostData(`/getnoticesbytypedeptv1`, d).then((resp) => {
      const all = Array.isArray(resp) ? resp : [];

      // newest -> oldest by the entered date
      const sorted = [...all].sort(
        (a, b) => this.__toTime(b.date) - this.__toTime(a.date)
      );

      // keep only the most recent month present in the data
      let news = [];
      if (sorted.length > 0) {
        const latestKey = this.__ymKey(sorted[0].date);
        news = sorted.filter((el) => this.__ymKey(el.date) === latestKey);
      }

      this.setState({
        news,
        isLoaded: true,
      });
    });
  }



  render() {
    return (
      <div>
        <div>
        
          {this.state.isLoaded ? (<a href={this.props.dept_code ? `/department/${this.props.dept_code}/events` : this.props.link}><marquee style={{width: '100%', height: '300px'}} scrolldelay="2" scrollamount="2" direction="up"  gradient={false}>
                        {this.state.news.map((el, index) => {
                        
                            return (
                                <Link to={el.link} key={index}>
                                    <NewsCard
                                        {...el}
                                      
                                    />
                                </Link>
                            )
                        })}
                    </marquee></a>) : null}

                    {this.state.isLoaded && <>
                      <div style={{textAlign: "right"}}>
                        <Button type="primary" href={this.props.dept_code ? `/department/${this.props.dept_code}/events` : this.props.link}>View All</Button>
                      </div>
                    </>}
          {/* {this.state.isLoaded ? (
            <Marquee
              duration={50}
              height="800px"
              width="100%"
              // axis="X"
              // align="left"
              direction="down"
              pauseOnHover={true}
              reverse={true}
              autoplay={false}
            >
              {this.state.news.map((el, index) => {
                return (
                  <Link href={el.link} key={index}>
            
                    <NewsCard {...el} />
                  </Link>
                );
              })}
            </Marquee>
          ) : null} */}
        </div>
      </div>
    );
  }
}

const NewsCard = (props) => {

  return (
    <div
      style={{
        marginBottom: "5px",
        backgroundColor: "Transparent",
        width: "100%",
      }}
    >
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
        }}
      >
        <div style={{width:'75%'}}>
          <Typography variant="caption" style={{ color: "#000E" }}>
            {props.date_no} - {props.month} {props.year}
          </Typography>
          <Typography variant="body2" style={{ color: "#B94735", fontSize: 14 }}>
            {props.title}
          </Typography>
        </div>
       
        {props.diff && (
          <img
            src="/images/icons/new-blink-pic.gif"
            style={{ width: "40px" }}
          />
        )}
        
      </div>
    </div>
  );
};
